module.exports = __webpack_public_path__ + "static/media/af.071b4bb7.svg";